import { useState, useEffect } from 'react';
import { MarketplaceAuth } from './components/MarketplaceAuth';
import { MarketplaceRegister } from './components/MarketplaceRegister';
import { InvoicePageMarketplace } from './components/InvoicePageMarketplace';
import { MARKETPLACE_URL } from './config';

/**
 * App - Main application component.
 * 
 * Authentication is handled via AWS Marketplace JWT tokens.
 * 
 * Routes:
 * - /register: Post-Marketplace registration form
 * - /error: Error page for failed registrations
 * - /: Main application
 */
function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  // Simple client-side routing
  useEffect(() => {
    const handlePopState = () => setCurrentPath(window.location.pathname);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Handle /register route - post-Marketplace registration form
  if (currentPath === '/register') {
    return (
      <MarketplaceRegister 
        onComplete={() => {
          setCurrentPath('/');
          window.history.pushState({}, '', '/');
        }} 
      />
    );
  }

  // Handle /error route - registration errors
  if (currentPath === '/error') {
    const params = new URLSearchParams(window.location.search);
    const reason = params.get('reason') || 'unknown';
    
    const errorMessages = {
      invalid_token: 'The registration token is invalid or has expired.',
      registration_failed: 'Error processing registration. Please try again.',
      unknown: 'An unexpected error occurred.',
    };

    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2>Error</h2>
          <div className="auth-error" style={{ marginTop: '1rem' }}>
            {errorMessages[reason] || errorMessages.unknown}
          </div>
          <a
            href={MARKETPLACE_URL}
            className="btn-primary"
            style={{ marginTop: '1.5rem', textDecoration: 'none', display: 'block', textAlign: 'center' }}
          >
            Back to AWS Marketplace
          </a>
          <button
            className="btn-secondary"
            style={{ marginTop: '0.75rem', width: '100%' }}
            onClick={() => {
              setCurrentPath('/');
              window.history.pushState({}, '', '/');
            }}
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  // Main application with Marketplace auth
  return (
    <MarketplaceAuth>
      {({ user, subscription, signOut }) => (
        <div className="app">
          <header className="app-header">
            <h1>AI Node</h1>
            <div className="user-info">
              <span>{user?.email || user?.customerId || 'User'}</span>
              {subscription?.status === 'active' && (
                <span className="subscription-badge">Active</span>
              )}
              <button onClick={signOut} className="btn-logout">
                Sign Out
              </button>
            </div>
          </header>
          <main>
            <InvoicePageMarketplace />
          </main>
          <footer className="footer">
            powered by <a href="https://surus.dev" target="_blank" rel="noopener noreferrer">SURUS AI Nodes</a>
          </footer>
        </div>
      )}
    </MarketplaceAuth>
  );
}

export default App;
